import { ALLOWED_DISCIPLINE_STATES, PIC_INSPECTOR_ROLES } from 'app/api_v2/agency/disciplines';
import { useGetInspectorDisciplinesQuery } from 'app/api_v2/agency/queries';
import { useAuthQuery } from 'app/api_v2/auth/queries';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import React from 'react';
import { Navigate } from 'react-router-dom';

interface HasToBeAgencyGuardProps {
  children: React.ReactNode;
}

export const HasToBePicGuard = (props: HasToBeAgencyGuardProps) => {
  const { children } = props;

  const { isSuccess, isLoading, data } = useAuthQuery();

  const {
    isSuccess: isDisciplinesSuccess,
    isLoading: isDisciplinesLoading,
    data: inspectorDisciplines,
  } = useGetInspectorDisciplinesQuery(data?.id || '');

  if (isSuccess && !data) {
    console.log('User is not logged in, redirecting to login page');
    return <Navigate to={'/auth/login'} />;
  }

  if (isSuccess && isDisciplinesSuccess && inspectorDisciplines && inspectorDisciplines.length > 0) {
    const picRoles = inspectorDisciplines
      .filter((item) => ALLOWED_DISCIPLINE_STATES.includes(item.state))
      .filter((item) => PIC_INSPECTOR_ROLES.includes(item.roleType));

    if (picRoles.length === 0) {
      console.log('User is not a PIC, redirecting to agency page');
      return <Navigate to={'/agency'} />;
    }
  }

  if (isSuccess && isDisciplinesSuccess) {
    return <>{children}</>;
  }
  if (isLoading || isDisciplinesLoading) {
    return <DataLoader />;
  }
  return null;
};
